import { useState, useRef, useEffect } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./PlanSale.css";

export default function PlanSale() {
  // Define your property plans here with their images
  const propertyPlans = [
    {
      id: 1,
      title: "TONINO LAMBORGHINI RESIDENCES",
      description: "Dubai",
      images: [
        "/assets/plan1-img1.jpg",
        "/assets/plan1-img2.jpg",
        "/assets/plan1-img3.jpg",
        "/assets/plan1-img4.jpg",
        "/assets/plan1-img5.jpg",
        "/assets/plan1-img6.jpg",
        "/assets/plan1-img7.jpg",
        "/assets/plan1-img8.jpg"
      ]
    },
    {
      id: 2,
      title: "Modern Apartment",
      description: "Dubai",
      images: [
        "/assets/plan2-img1.jpg",
        "/assets/plan2-img2.jpg",
        "/assets/plan2-img3.jpg",
        "/assets/plan2-img4.jpg",
        "/assets/plan2-img5.jpg",
        "/assets/plan2-img6.jpg",
        "/assets/plan2-img7.jpg",
        "/assets/plan2-img8.jpg",
        "/assets/plan2-img9.jpg",
        "/assets/plan2-img10.jpg",
        "/assets/plan2-img11.jpg",
        "/assets/plan2-img12.jpg",
        "/assets/plan2-img13.jpg",
      ]
    },
    {
      id: 3,
      title: "SquareX ONE Inventory",
      description: "Jumeirah Village Circle (JVC)",
      details: {
        paymentPlan: "60/40 (custom plans available)",
        completion: "December 2026",
        commission: "5%",
        features: [
          "1 bed with study and pool",
          "Bosch appliances",
          "Fully fitted apartments",
          "Ongoing construction and active escrow accounts"
        ]
      },
      contactInfo: {
        agent: "Shamjid",
        phone: "+971589167256",
        message: "Feel free to call or message for more sales offers"
      },
      images: [
        "/assets/plan3-img1.jpg",
      ]
    },
    {
      id: 4,
      title: "V-SUITES",
      description: "Business Bay",
      details: {
        paymentPlan: "30/20/50",
        completion: "Q3 2027",
        features: [
          "Fully Furnished",
          "Branded residences",
          "22 Premium amenities"
        ],
        booking: "Immediate 10% or 100,000 AED to block any unit"
      },
      units: [
        {
          name: "Unit 101",
          type: "2BHK",
          features: "Private garden & private pool",
          size: "2000 sqft",
          price: "5,265,777 AED"
        },
        {
          name: "Unit 205",
          type: "1BHK",
          features: "Most affordable unit - Park views",
          size: "700 sqft",
          price: "2,432,777 AED"
        },
        {
          name: "Unit 1411",
          type: "Studio",
          features: "Canal and Burj view - High floor",
          size: "N/A",
          price: "1,725,777 AED"
        }
      ],
      offMarket: "High floor 1BHKs available - Contact agent",
      contactInfo: {
        agent: "Shamjid",
        phone: "+971589167256",
        message: "Message for more details"
      },
      images: [
        "/assets/plan4-img1.jpg",
        "/assets/plan4-img2.jpg",
        "/assets/plan4-img3.jpg",
        "/assets/plan4-img4.jpg",
      ]
    },
    {
      id: 5,
      title: "Azizi Rose Factsheet",
      description: "Dubai",
      images: [
        "/assets/plan5-img1.jpg",
        "/assets/plan5-img2.jpg",
      ]
    },
    {
      id: 6,
      title: "Azizi Rose",
      description: "Dubai",
      images: [
        "/assets/plan6-img1.jpg",
        "/assets/plan6-img2.jpg",
      ]
    },
    {
      id: 7,
      title: "Tonino Lamborghini",
      description: "Dubai",
      images: [
        "/assets/plan7-img1.jpg",
        "/assets/plan7-img2.jpg",
        "/assets/plan7-img3.jpg",
        "/assets/plan7-img4.jpg",
        "/assets/plan7-img5.jpg",
        "/assets/plan7-img6.jpg",
        "/assets/plan7-img7.jpg",
        "/assets/plan7-img8.jpg",
        "/assets/plan7-img9.jpg",
        "/assets/plan7-img10.jpg",
        "/assets/plan7-img11.jpg",
        "/assets/plan7-img12.jpg",
      ]
    },
    {
      id: 8,
      title: "Taj Wellington",
      description: "Dubai",
      images: [
        "/assets/plan8-img1.jpg",
        "/assets/plan8-img2.jpg",
      ]
    },
    {
      id: 9,
      title: "Ramada Residence - Al Jaddaf",
      description: "Dubai",
      images: [
        "/assets/plan9-img1.jpg",
        "/assets/plan9-img2.jpg",
        "/assets/plan9-img3.jpg",
        "/assets/plan9-img4.jpg",
        "/assets/plan9-img5.jpg",
        "/assets/plan9-img6.jpg",
      ]
    },
    {
      id: 10,
      title: "Pelagia",
      description: "Dubai",
      images: [
        "/assets/plan10-img1.jpg",
        "/assets/plan10-img2.jpg",
        "/assets/plan10-img3.jpg",
        "/assets/plan10-img4.jpg",
      ]
    },
    {
      id: 11,
      title: "La Perla",
      description: "Dubai",
      images: [
        "/assets/plan11-img1.jpg",
        "/assets/plan11-img2.jpg",
        "/assets/plan11-img3.jpg",
      ]
    },
    {
      id: 12,
      title: "Fashion TV - Acacia",
      description: "Dubai",
      images: [
        "/assets/plan12-img1.jpg",
        "/assets/plan12-img2.jpg",
        "/assets/plan12-img3.jpg",
      ]
    },
    {
      id: 13,
      title: "Aquino",
      description: "Dubai",
      images: [
        "/assets/plan13-img1.jpg",
      ]
    },
    {
      id: 14,
      title: "Aqua Arc",
      description: "Dubai",
      images: [
        "/assets/plan14-img1.jpg",
        "/assets/plan14-img2.jpg",
        "/assets/plan14-img3.jpg",
        "/assets/plan14-img4.jpg",
      ]
    },
    {
      id: 15,
      title: "Mahra Brochure",
      description: "Dubai",
      images: [
        "/assets/plan15-img1.jpg",
        "/assets/plan15-img2.jpg",
        "/assets/plan15-img3.jpg",
        "/assets/plan15-img4.jpg",
        "/assets/plan15-img5.jpg",
        "/assets/plan15-img6.jpg",
        "/assets/plan15-img7.jpg",
        "/assets/plan15-img8.jpg",
        "/assets/plan15-img9.jpg",
        "/assets/plan15-img10.jpg",
        "/assets/plan15-img11.jpg",
        "/assets/plan15-img12.jpg",
        "/assets/plan15-img13.jpg",
        "/assets/plan15-img14.jpg",
        "/assets/plan15-img15.jpg",
        "/assets/plan15-img16.jpg",
        "/assets/plan15-img17.jpg",
        "/assets/plan15-img18.jpg",
        "/assets/plan15-img19.jpg",
        "/assets/plan15-img20.jpg",
        "/assets/plan15-img21.jpg",
        "/assets/plan15-img22.jpg",
        "/assets/plan15-img23.jpg",
        "/assets/plan15-img24.jpg",
        "/assets/plan15-img25.jpg",
        "/assets/plan15-img26.jpg"
      ]
    },
    {
      id: 16,
      title: "Expo Valley ",
      description: "Dubai",
      images: [
        "/assets/plan16-img1.jpg",
        "/assets/plan16-img2.jpg",
        "/assets/plan16-img3.jpg",
        "/assets/plan16-img4.jpg",
        "/assets/plan16-img5.jpg",
      ]
    },
   
  ];

  const [currentImageIndexes, setCurrentImageIndexes] = useState(
    propertyPlans.map(() => 0)
  );
  const [downloadingPlan, setDownloadingPlan] = useState(null);
  const planRefs = useRef([]);

  // Navigate to previous image for specific plan
  const prevImage = (planIndex) => {
    setCurrentImageIndexes(prev => {
      const newIndexes = [...prev];
      const totalImages = propertyPlans[planIndex].images.length;
      newIndexes[planIndex] = prev[planIndex] === 0 ? totalImages - 1 : prev[planIndex] - 1;
      return newIndexes;
    });
  };

  // Navigate to next image for specific plan
  const nextImage = (planIndex) => {
    setCurrentImageIndexes(prev => {
      const newIndexes = [...prev];
      const totalImages = propertyPlans[planIndex].images.length;
      newIndexes[planIndex] = prev[planIndex] === totalImages - 1 ? 0 : prev[planIndex] + 1;
      return newIndexes;
    });
  };

  // Navigate to specific image for specific plan
  const goToImage = (planIndex, imageIndex) => {
    setCurrentImageIndexes(prev => {
      const newIndexes = [...prev];
      newIndexes[planIndex] = imageIndex;
      return newIndexes;
    });
  };

  // Scroll to specific plan
  const scrollToPlan = (planIndex) => {
    planRefs.current[planIndex]?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'center'
    });
  };

  // Download plan images as PDF with HIGH QUALITY
  const downloadPlanAsPDF = async (planIndex) => {
    const plan = propertyPlans[planIndex];
    setDownloadingPlan(planIndex);

    try {
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 10;

      // Add title page
      pdf.setFontSize(20);
      pdf.text(plan.title, pageWidth / 2, 40, { align: 'center' });
      pdf.setFontSize(14);
      pdf.text(plan.description, pageWidth / 2, 55, { align: 'center' });
      pdf.setFontSize(10);
      pdf.text(`Total Images: ${plan.images.length}`, pageWidth / 2, 70, { align: 'center' });

      // Process each image with HIGH QUALITY settings
      for (let i = 0; i < plan.images.length; i++) {
        pdf.addPage();

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';

        const img = new Image();
        img.crossOrigin = 'anonymous';
        
        await new Promise((resolve, reject) => {
          img.onload = () => {
            try {
              const scale = 2;
              const imgWidth = img.width;
              const imgHeight = img.height;
              const ratio = imgWidth / imgHeight;

              let finalWidth = pageWidth - (2 * margin);
              let finalHeight = finalWidth / ratio;

              if (finalHeight > pageHeight - (2 * margin) - 20) {
                finalHeight = pageHeight - (2 * margin) - 20;
                finalWidth = finalHeight * ratio;
              }

              canvas.width = finalWidth * scale * 3.78;
              canvas.height = finalHeight * scale * 3.78;

              ctx.imageSmoothingEnabled = true;
              ctx.imageSmoothingQuality = 'high';

              ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

              const imgData = canvas.toDataURL('image/jpeg', 1.0);

              const xPos = (pageWidth - finalWidth) / 2;
              const yPos = 20;

              pdf.addImage(imgData, 'JPEG', xPos, yPos, finalWidth, finalHeight, undefined, 'FAST');

              pdf.setFontSize(10);
              pdf.text(
                `Image ${i + 1} of ${plan.images.length}`,
                pageWidth / 2,
                pageHeight - 10,
                { align: 'center' }
              );

              resolve();
            } catch (error) {
              reject(error);
            }
          };
          img.onerror = reject;
          img.src = plan.images[i];
        });
      }

      const fileName = `${plan.title.replace(/\s+/g, '_')}_Plans.pdf`;
      pdf.save(fileName);

    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');
    } finally {
      setDownloadingPlan(null);
    }
  };

  return (
    <div className="plan-sale-container">
      <div className="plan-sale-header">
        <h1>Property Plans & Sale</h1>
        <p>Browse through our exclusive property plans</p>
      </div>

      {/* All Plans Display */}
      <div className="all-plans-wrapper">
        {propertyPlans.map((plan, planIndex) => (
          <div 
            key={plan.id}
            ref={el => planRefs.current[planIndex] = el}
            className="plan-section"
          >
            <div className="plan-content">
              {/* Plan Information */}
              <div className="plan-info">
                <h2>{plan.title}</h2>
                <p className="plan-location">{plan.description}</p>
                
                {/* Property Details */}
                {plan.details && (
                  <div className="property-details">
                    {plan.details.paymentPlan && (
                      <div className="detail-item">
                        <span className="detail-label">Payment Plan:</span>
                        <span className="detail-value">{plan.details.paymentPlan}</span>
                      </div>
                    )}
                    {plan.details.completion && (
                      <div className="detail-item">
                        <span className="detail-label">Completion:</span>
                        <span className="detail-value">{plan.details.completion}</span>
                      </div>
                    )}
                    {plan.details.commission && (
                      <div className="detail-item">
                        <span className="detail-label">Commission:</span>
                        <span className="detail-value">{plan.details.commission}</span>
                      </div>
                    )}
                    {plan.details.booking && (
                      <div className="detail-item booking-highlight">
                        <span className="detail-value">{plan.details.booking}</span>
                      </div>
                    )}
                    {plan.details.features && (
                      <div className="features-list">
                        <h4>Key Features:</h4>
                        <ul>
                          {plan.details.features.map((feature, index) => (
                            <li key={index}>{feature}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}

                {/* Available Units */}
                {plan.units && (
                  <div className="units-section">
                    <h3>Units of the Day</h3>
                    <div className="units-grid">
                      {plan.units.map((unit, index) => (
                        <div key={index} className="unit-card">
                          <div className="unit-header">
                            <span className="unit-name">{unit.name}</span>
                            <span className="unit-type">{unit.type}</span>
                          </div>
                          <div className="unit-details">
                            <p className="unit-features">{unit.features}</p>
                            {unit.size !== "N/A" && (
                              <p className="unit-size">{unit.size}</p>
                            )}
                          </div>
                          <div className="unit-price">{unit.price}</div>
                        </div>
                      ))}
                    </div>
                    {plan.offMarket && (
                      <div className="off-market">
                        <span className="off-market-badge">OFF MARKET</span>
                        <p>{plan.offMarket}</p>
                      </div>
                    )}
                  </div>
                )}

                {/* Contact Information */}
                {plan.contactInfo && (
                  <div className="contact-info">
                    <p className="contact-message">{plan.contactInfo.message}</p>
                    <div className="contact-details">
                      <p className="agent-name">{plan.contactInfo.agent}</p>
                      <a href={`tel:${plan.contactInfo.phone}`} className="phone-link">
                        {plan.contactInfo.phone}
                      </a>
                    </div>
                  </div>
                )}

                <div className="plan-meta">
                  <span>Plan {planIndex + 1} of {propertyPlans.length}</span>
                  <span>•</span>
                  <span>{plan.images.length} Images</span>
                </div>
                
                {/* Download PDF Button */}
                <button 
                  className="download-pdf-btn"
                  onClick={() => downloadPlanAsPDF(planIndex)}
                  disabled={downloadingPlan === planIndex}
                >
                  {downloadingPlan === planIndex ? (
                    <>
                      <span className="spinner"></span>
                      Generating PDF...
                    </>
                  ) : (
                    <>
                      <svg 
                        width="20" 
                        height="20" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2"
                      >
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="7 10 12 15 17 10" />
                        <line x1="12" y1="15" x2="12" y2="3" />
                      </svg>
                      Download PDF ({plan.images.length} images)
                    </>
                  )}
                </button>
              </div>

              {/* Image Slider */}
              <div className="image-slider">
                <button 
                  className="slider-arrow left" 
                  onClick={() => prevImage(planIndex)}
                >
                  ‹
                </button>

                <div className="slider-image-container">
                  <img 
                    src={plan.images[currentImageIndexes[planIndex]]} 
                    alt={`${plan.title} - Image ${currentImageIndexes[planIndex] + 1}`}
                    className="slider-image"
                    loading="eager"
                  />
                  <div className="image-counter">
                    {currentImageIndexes[planIndex] + 1} / {plan.images.length}
                  </div>
                </div>

                <button 
                  className="slider-arrow right" 
                  onClick={() => nextImage(planIndex)}
                >
                  ›
                </button>
              </div>

              {/* Image Dots Navigation */}
              <div className="image-dots">
                {plan.images.map((_, imageIndex) => (
                  <button
                    key={imageIndex}
                    className={`dot ${imageIndex === currentImageIndexes[planIndex] ? "active" : ""}`}
                    onClick={() => goToImage(planIndex, imageIndex)}
                    aria-label={`Go to image ${imageIndex + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
